import styled, { css } from 'styled-components';
import { FIELD_MAX_HEIGHT, ELEMENT_MAX_WIDTH } from 'styles';
import { SPACING_4 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';

export default {
  Wrapper: styled.div`
    ${props => css`direction: ${(props.RTL || props.$rtl || props.rtl) ? 'rtl' : 'ltr'};`}
    display: flex;
    flex-direction: column;
    width: ${props => (props.resize === 'none' || props.resize === 'vertical') ? '100%' : 'initial'};
    ${props => props.maxWidth ? css`
      max-width: ${ELEMENT_MAX_WIDTH};
    ` : css`
      max-width: 100%;
    `}
  `,
  RowWrapper: styled.div`
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    & textarea {
      caret-color: ${props => props.theme.caret};
    }
    & textarea::-webkit-resizer {
      display: none;   
    }
  `,
  MetaContainer: styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    max-height: ${FIELD_MAX_HEIGHT};
    max-width: 100%;
    margin-top: ${SPACING_4};
    ${({ fieldWidth }) => css`
      ${fieldWidth ? `width:${fieldWidth}px;` : 'width: 100%;'}
      ${fieldWidth === 0 ? 'display: none;' : 'display: flex;'}
    `}
  `
};